import { render, staticRenderFns } from "./integreSistema.vue?vue&type=template&id=dd25f8c8&scoped=true&"
import script from "./integreSistema.vue?vue&type=script&lang=js&"
export * from "./integreSistema.vue?vue&type=script&lang=js&"
import style0 from "./integreSistema.vue?vue&type=style&index=0&id=dd25f8c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25f8c8",
  null
  
)

export default component.exports